function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 0.769,
  y1: 0.835,
  x2: 0.177,
  y2: 0.205,
  gradientUnits: "objectBoundingBox"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#004683",
  stopOpacity: 0.82
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_4",
  "data-name": "Layer 4",
  transform: "translate(-320.436 -52.639)",
  opacity: 0.9
}, React.createElement("g", {
  id: "Group_6",
  "data-name": "Group 6"
}, React.createElement("path", {
  id: "Path_7",
  "data-name": "Path 7",
  d: "M347.006,131.277c0-11.488,14.774-49.189,65.318-54.747",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 9
}), React.createElement("path", {
  id: "Path_20",
  "data-name": "Path 20",
  d: "M100,0A100,100,0,1,1,0,100,100,100,0,0,1,100,0Z",
  transform: "translate(320.436 52.639)",
  fill: "url(#linear-gradient)"
}), React.createElement("rect", {
  id: "Rectangle_3",
  "data-name": "Rectangle 3",
  width: 90.289,
  height: 55.758,
  transform: "translate(375.044 129.76)",
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 5
}), React.createElement("g", {
  id: "Group_5",
  "data-name": "Group 5",
  transform: "translate(0 5)"
}, React.createElement("g", {
  id: "Settings"
}, React.createElement("g", {
  id: "Group_4",
  "data-name": "Group 4"
}, React.createElement("path", {
  id: "Path_8",
  "data-name": "Path 8",
  d: "M437.512,150.723a1.122,1.122,0,0,0-1.109-.849,3.809,3.809,0,0,1-2.607-6.629.958.958,0,0,0,.105-1.3,17.035,17.035,0,0,0-2.733-2.76.959.959,0,0,0-1.311.106,3.974,3.974,0,0,1-4.3.966,3.83,3.83,0,0,1-2.33-3.745.957.957,0,0,0-.847-1.007,17.24,17.24,0,0,0-3.88-.011.961.961,0,0,0-.855.987,3.836,3.836,0,0,1-2.362,3.681,3.987,3.987,0,0,1-4.27-.972.962.962,0,0,0-1.3-.11,17.135,17.135,0,0,0-2.79,2.759.959.959,0,0,0,.1,1.311,3.823,3.823,0,0,1,.964,4.3,3.988,3.988,0,0,1-3.753,2.332.937.937,0,0,0-1,.847,17.269,17.269,0,0,0-.008,3.923,1.141,1.141,0,0,0,1.131.848,3.783,3.783,0,0,1,3.549,2.364,3.833,3.833,0,0,1-.964,4.265.959.959,0,0,0-.105,1.3,17.135,17.135,0,0,0,2.729,2.761.958.958,0,0,0,1.313-.1,3.97,3.97,0,0,1,4.3-.967,3.825,3.825,0,0,1,2.334,3.744.958.958,0,0,0,.847,1.007,17.094,17.094,0,0,0,3.88.011.959.959,0,0,0,.854-.988,3.836,3.836,0,0,1,2.361-3.679,3.983,3.983,0,0,1,4.272.972.964.964,0,0,0,1.3.109,17.173,17.173,0,0,0,2.79-2.759.957.957,0,0,0-.1-1.311,3.822,3.822,0,0,1-.966-4.3,3.862,3.862,0,0,1,3.529-2.339l.213.006a.96.96,0,0,0,1.009-.846A17.269,17.269,0,0,0,437.512,150.723ZM420.4,158.429a5.754,5.754,0,1,1,5.754-5.754A5.76,5.76,0,0,1,420.4,158.429Z",
  fill: "#fff"
}))))));

var SvgBack = function SvgBack(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/back.4db6bb93.svg";
export { ForwardRef as ReactComponent };